<div class="container">
	<div [innerHTML]="content"></div>
</div>